import { suggestionCanvas } from '@/workspace/knowledge-pages/suggestion-link';
import type { CanvasTarget } from '@/workspace/types';
import type { ActionView } from './action-confirmation';

/** Destination comes from the confirmed domain receipt, never guessed draft IDs. */
export function actionResultTarget(action: ActionView): CanvasTarget | null {
  if (action.status !== 'executed' || !action.result || typeof action.result !== 'object')
    return null;
  const result = action.result as Record<string, unknown>;
  const fields: Record<string, [string, CanvasTarget['kind']]> = {
    create_skill_draft: ['skill', 'skill'],
    update_skill_draft: ['skill', 'skill'],
    create_agent: ['agent', 'agent'],
    update_agent: ['agent', 'agent'],
    set_agent_trigger: ['agent', 'agent'],
    save_work_result: ['result', 'result'],
    add_meeting_note: ['meeting', 'meeting'],
    propose_knowledge_change: ['proposal', 'page-proposal'],
  };
  if (action.tool === 'build_artifact') {
    // The queued build's own receipt: its job and the Artifact it will become, never a guess.
    const target = result.target as Record<string, unknown> | null | undefined;
    if (
      result.status !== 'queued' ||
      typeof result.jobId !== 'string' ||
      !target ||
      typeof target.artifactId !== 'string'
    )
      return null;
    return {
      kind: 'artifact-draft',
      id: target.artifactId,
      jobId: result.jobId,
      ...(action.answerMessageId ? { activityMessageId: action.answerMessageId } : {}),
    } as CanvasTarget;
  }
  // A suggested page change is reviewed on its page, with the suggestion in focus.
  if (action.tool === 'suggest_page_edits') return suggestionCanvas(result);
  const mapping = fields[action.tool];
  if (!mapping) return null;
  const item = result[mapping[0]];
  if (!item || typeof item !== 'object' || !('id' in item) || typeof item.id !== 'string')
    return null;
  return {
    kind: mapping[1],
    id: item.id,
    ...(mapping[1] !== 'page-proposal' && action.answerMessageId
      ? { activityMessageId: action.answerMessageId }
      : {}),
  } as CanvasTarget;
}
